import { PropsWithChildren, ReactNode, createContext } from "react";

import { INotificationsContext } from "shared/providers/Layout/components/NewTopBar/types/notifications";

export const NotificationsContext = createContext<INotificationsContext>(
  {} as INotificationsContext,
);

export const NotificationsContextProvider = ({
  children,
}: PropsWithChildren<ReactNode>) => {
  return (
    <NotificationsContext.Provider value={{}}>
      {children}
    </NotificationsContext.Provider>
  );
};
